import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchResults = (params) => {
    return axios.get('/api/v1/orders/orders_transition_metas/', { params });
};

export const fetchNode = (id) => {
    return axios.get(`/api/v1/orders/orders_transition_metas/${id}/`);
};

export const fetchSchema = () => {
    return axios.get('/api/v1/orders/orders_transition_metas/allowed_actions/');
};

export const fetchGraph = (id) => {
    return axios.get(`/api/v1/orders/orders_transition_metas/${id}/graph/`);
};

export const setGraph = (id, graph) => {
    return axios.post(`/api/v1/orders/orders_transition_metas/${id}/set_graph/`, { graph });
};

export const fetchAllowedActions = (params) => {
    return axios.get('/api/v1/orders/orders_transition_metas/allowed_actions/', { params });
};
